import Home from "./pages/Home";
import Community from "./pages/Community";
import Communities from "./pages/Communities";
import Section from "./pages/Section";
import Dashboard from "./pages/Dashboard";
import Banking from "./pages/Banking";
import Member from "./pages/Member";
import Content from "./pages/Content";
import Material from './pages/Material'
import CommunityConfig from './pages/CommunityConfig'
import Components from './pages/Components'

import { useLocation } from "react-router-dom";

import "./App.css";
import "./assets/spacing.css";

import React, { useState, useEffect, useMemo, useRef } from "react";
import { Routes, BrowserRouter, Route } from "react-router-dom";

import { Confirm } from "@fragments";
import UserModal from "@components/Modals/UserModal";
import ShareContentModal from "@components/Modals/ShareContentModal/index.js";

import { AuthProvider, useAuth } from "@contexts/AuthContext.js";
import { CommunityProvider, useCommunity } from "contexts/community";

import { ThemeProvider } from "@mui/material/styles";

import { ReactComponent as WhiteLogoSVG } from "@assets/logo/M_WHITE_LOGO_FULL.svg";

import theme from "./assets/theme.js";

import H from "@helpers/H.js";

// Importando os componentes comuns do Screen
import { Header, Sidebar, Chats } from "@components/Screen";

const routes = {
  members: Home,
  '': Communities,
  dashboard: Dashboard,
  "/:slug": Community,

  ":slug/settings": CommunityConfig,
  ":slug/settings/:tab": CommunityConfig,

  ":slug/section/:section": Section,
  ":slug/section/:section/:content": Content,

  ":slug/materials/:materialId": Material,


  "banking": Banking,
  "banking/charges": Banking,
  "banking/subscriptions": Banking,
  "banking/anticipations": Banking,
  "banking/withdrawal": Banking,
  "user/:id": Member,
  "components": Components,
};

function App() {
  window.setBackgroundEffect = () => { };

  window.triggerAppearence = (value) => {
    if (value !== 'dark' && value !== 'light') value = 'toggle'
    return handleSetAppearence(value)
  }

  // Inicializa a aparência apenas se ainda não foi definida
  if (!window.appearenceMode) {
    handleSetAppearence(null)
  }

  useEffect(() => {

  }, [])

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <CommunityProvider>
            <ProtectedRoutes />
          </CommunityProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

function handleSetAppearence(mode = null) {
  let currentState = localStorage.getItem('system_appearence') || null

  if (mode === 'toggle') {
    // Toggle: alterna entre dark e light
    currentState = currentState === 'dark' ? 'light' : 'dark'
  } else if (mode === 'dark' || mode === 'light') {
    // Se um modo específico foi passado, usa ele
    currentState = mode
  } else if (!currentState) {
    // Se não existe no localStorage, tenta detectar a preferência do SO
    try {
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      currentState = prefersDark ? 'dark' : 'light'
    } catch (e) {
      // Se não conseguir detectar, usa 'light' como padrão
      currentState = 'light'
    }
  }
  // Se já existe no localStorage e nenhum modo foi passado, mantém o valor atual

  localStorage.setItem('system_appearence', currentState)

  window.appearenceMode = currentState

  document.querySelector('body').className = `${currentState}`

  // Dispara o evento para notificar os listeners
  window.dispatchEvent(new CustomEvent('appearence-change', { detail: currentState }))

  return currentState
}

const ProtectedRoutes = () => {
  const { signed, loading } = useAuth();
  const location = useLocation();
  const screenContentRef = useRef(null);

  window.helpers = H;

  // Efeito para fazer scroll para o top sempre que a rota mudar
  useEffect(() => {
    if (screenContentRef.current) {
      screenContentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [location.pathname]);

  // Componentes comuns memoizados para evitar re-render
  const memoizedHeader = useMemo(() => <Header />, []);
  const memoizedSidebar = useMemo(() => <Sidebar />, []);
  const memoizedChats = useMemo(() => <Chats />, []);

  if (!signed && loading) return <LoadingComponent />;

  return (
    <div className="screen">
      {memoizedSidebar}

      <div ref={screenContentRef} className="screen-content">
        {memoizedHeader}

        <Routes>
          {Object.keys(routes).map((path, i) => {
            const Component = routes[path];
            return (
              <Route
                path={"/" + path}
                key={i}
                element={
                  <>
                    <Confirm />
                    <UserModal />
                    <Component />
                    <ShareContentModal />
                  </>
                }
              />
            );
          })}
        </Routes>
      </div>

      {memoizedChats}
    </div>
  );
};

export default App;

const LoadingComponent = ({ }) => {
  return (
    <div className="loading-screen">
      <WhiteLogoSVG />
    </div>
  );
};
